import { ERROR_MESSAGES } from "../constants/errorMessages";

const generateError = (error) => {
  let errMessage = "";
  console.log({ ...error });
  if (error && error.response && error.response.status) {
    switch (error.response.status) {
      case 401:
        errMessage = ERROR_MESSAGES.ERROR_401;
        break;
      case 403:
        errMessage = ERROR_MESSAGES.ERROR_403;
        break;
      case 404:
        errMessage = ERROR_MESSAGES.ERROR_404;
        break;
      case 500:
        if (
          error.response.data &&
          error.response.data.error &&
          Array.isArray(error.response.data.error) &&
          error.response.data.error[0] === ERROR_MESSAGES.ERROR_DUPLICATE
        ) {
          errMessage = ERROR_MESSAGES.ERROR_DUPLICATE;
          break;
        }
        errMessage = ERROR_MESSAGES.ERROR_500;
        break;
      default:
        if (error.response.data && error.response.data.error) {
          errMessage = JSON.stringify(error.response.data.error);
        } else {
          errMessage = JSON.stringify(error.response.data);
        }
        break;
    }
    errMessage = `Error : ${errMessage} (Code: ${error.response.status})`;
  } else {
    errMessage = ERROR_MESSAGES.ERROR_UNKNOWN;
  }
  return errMessage;
};

export default generateError;



// WEBPACK FOOTER //
// ./src/utilities/generateError.js